import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useRef } from 'react';
import './LinearGauge.scss';
export const LinearGauge = ({ value, label, max, compact, slim, inverted, dimmed, ranking }) => {
    const gaugeParentRef = useRef(null);
    const [gaugeWidth, setGaugeWidth] = useState(0);
    const [currentX, setCurrentX] = useState(0);
    const animationRef = useRef(null);
    useEffect(() => {
        if (gaugeParentRef.current) {
            const actualWidth = gaugeParentRef.current.clientWidth - (compact ? 35 : 0) - 60 - 10;
            setGaugeWidth(actualWidth);
        }
    }, []);
    useEffect(() => {
        const xNominal = inverted
            ? gaugeWidth - ((gaugeWidth / max) * value)
            : (gaugeWidth / max) * value;
        let startTime = null;
        const startX = currentX;
        const step = (ts) => {
            if (startTime === null)
                startTime = ts;
            const delay = 250;
            const elapsed = ts - startTime;
            if (elapsed < delay) {
                const progress = elapsed / delay;
                setCurrentX(startX + (xNominal - startX) * progress);
                animationRef.current = requestAnimationFrame(step);
            }
            else {
                setCurrentX(xNominal);
                animationRef.current = null;
            }
        };
        if (animationRef.current) {
            cancelAnimationFrame(animationRef.current);
        }
        animationRef.current = requestAnimationFrame(step);
        return () => {
            if (animationRef.current) {
                cancelAnimationFrame(animationRef.current);
            }
        };
    }, [value, gaugeWidth, max, inverted]);
    const clsx = [
        'linear gauge',
        compact ? 'compact' : '',
        slim ? 'slim' : '',
        inverted ? 'inverted' : '',
        dimmed ? 'dimmed' : '',
        ranking && value ? 'ranking' : ''
    ].join(' ');
    const bg = _jsx("line", { className: "scale bg", x1: 8, y1: 8, x2: gaugeWidth - 8, y2: 8, vectorEffect: "non-scaling-stroke" });
    const fg = value ? _jsx("line", { className: "scale fg", x1: 8, y1: 8, x2: Math.max(currentX - 8, 8), y2: 8, vectorEffect: "non-scaling-stroke" }) : null;
    return (_jsxs("div", { className: clsx, ref: gaugeParentRef, children: [_jsx("div", { className: "label", children: label }), _jsxs("div", { className: "chart", children: [_jsx("figure", { children: _jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", version: "1.1", viewBox: `0 0 ${gaugeWidth} 16`, children: [bg, fg] }) }), _jsx("div", { className: "value", children: value })] })] }));
};
